export default __webpack_public_path__ + "static/media/PostgreSQL-WindowsTaskScheduler-Finish07.b41bfbe2.png";